import {AnimationClip, AnimationData} from '@wonderlandengine/tweenjs';
import IslandSharkCircleData from './IslandSharkCircle.json';

export class IslandSharkCircle extends AnimationClip {
    static TypeName = 'anim:IslandSharkCircle';
    static InheritProperties = true;

    public data: AnimationData = IslandSharkCircleData;
    public clipName: string = 'IslandSharkCircle';
}
